import { render, staticRenderFns } from "./view-supporter.vue?vue&type=template&id=2785661c&"
import script from "./view-supporter.vue?vue&type=script&lang=js&"
export * from "./view-supporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports